

import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

export default class TagPhotosDialog extends Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.state = {
      photoIndex: props.selectedIndex,
      isOpen: true,
    };
  }

  close() {
    this.setState({ isOpen: false });
    this.props.tagPhotosDialogClosed();
  }

  render() {
    const { photoIndex, isOpen } = this.state;
    let images = this.props.selectedTagPhotos.map(photo => {
      return {url: 'http://www.almotanabbi.com/streamTagPhoto.do?photoId=' + photo.photoId, description: photo.description.replace(/\<br\/>/gi, '')};
    });


    return (
      <div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex].url}
            nextSrc={images[(photoIndex + 1) % images.length].url}
            prevSrc={images[(photoIndex + images.length - 1) % images.length].url}
            imageCaption={images[photoIndex].description}
            onCloseRequest={this.close}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
          />
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/TagPhotosDialog.js